var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(("" + (_vm.$t("{0} users in total", [_vm.allUsers]))))+":")]),_vm._v(" "+_vm._s(_vm.roleString)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }